import * as Actions from "../../actions/app"
import { toggleIdInArray } from "utils/toggle-id-in-array"
import { addOrUpdateObjectInArray } from "utils/add-or-update-object-in-array"

const initialState = {
  loading_complements_by_product: false,
  complements_by_product: [],

  saving_complement: false,
  saved_complement: false,

  updating_complement_quantity_ids: [],
  updated_complement_quantity_ids: [],

  removing_complement_ids: [],
  removed_complement_ids: []
}

const productComplementsReducer = function (state = initialState, action) {
  switch (action.type) {
    case Actions.GET_COMPLEMENTS_BY_PRODUCT_ID: {
      return {
        ...state,
        loading_complements_by_product: action.payload.loading,
        complements_by_product: action.payload.data ?? state.complements_by_product
      }
    }
    case Actions.SAVE_PRODUCT_COMPLEMENT: {
      return {
        ...state,
        saved_complement: action.payload.saved ?? false,
        saving_complement: action.payload.saving ?? false,
        complements_by_product: action.payload.data
          ? addOrUpdateObjectInArray(state.complements_by_product, action.payload.data, 'idcomplemento')
          : state.complements_by_product
      }
    }
    case Actions.UPDATE_PRODUCT_COMPLEMENT_QUANTITY: {
      return {
        ...state,
        updating_complement_quantity_ids: toggleIdInArray(state.updating_complement_quantity_ids, action.payload.updating_id),
        updated_complement_quantity_ids: toggleIdInArray(state.updated_complement_quantity_ids, action.payload.updated_id),
        complements_by_product: action.payload.data
          ? addOrUpdateObjectInArray(state.complements_by_product, action.payload.data, 'idcomplemento')
          : state.complements_by_product
      }
    }
    case Actions.REMOVE_PRODUCT_COMPLEMENT: {
      return {
        ...state,
        removing_complement_ids: toggleIdInArray(state.removing_complement_ids, action.payload.removing_id),
        removed_complement_ids: toggleIdInArray(state.removed_complement_ids, action.payload.removed_id),
        complements_by_product: state.complements_by_product.filter(complement => complement.idcomplemento !== action.payload.removed_id)
      }
    }
    default: {
      return state
    }
  }
}
export default productComplementsReducer
